import { recalculateSessionAsync, setCustomAddon, fetchRequest } from "../../api/api.js";

// TODO: would be passed in as dependencies to make this module fully independent
async function fetchXCoverQuote() {
    let quoteData = null;
    let costData = null;
    
    try {
        // Recalculate base costs
        // Run recalculate (do we really need this? place_booking did it but not sure)
        await recalculateSessionAsync();

        // Get refund/cancellation quote
        const response = await fetchRequest('/cancellation/quote/');
        const quote    = await response.json();
        
        // quote premium = £0 = the value of the booking doesn't qualify for refund protection
        if (quote.premium == '&pound;0.00') {
            quoteData = { 
                canProtectBooking: false, 
                premium: quote.premium 
            };
        } else {
            quoteData = {
                canProtectBooking: true,
                termsUrl: quote.terms_url,
                salesMessage: quote.sales_message,
                totalToUse: quote.total_to_use,
                premium: quote.premium
            }
        }

        costData = await recalculateSessionAsync();
    } catch (err) {
        console.warn(err);
        return {
            status: 400,
            data: {
                err
            }
        }
    }
    
    return {
        status: 200,
        data: {
            costData,
            quoteData
        }
    }
}


// TODO: extractCustomAddonValue will handle the object building for me
// setCustomAddon will handle session setting/response for me
async function handleSetBookingProtectAsync(doUseXcover) {
// Set the addon in session using the following params
    const params = {
        addon_id: '',
        custom_type: 'xcover',
        custom: 1,
        addon_value: doUseXcover
    }

    const response = await setCustomAddon(params);
    return await response.data;
}

export { fetchXCoverQuote, handleSetBookingProtectAsync }